import { message } from "antd";
import * as ACTIONS from "app/actions/SystemActions";

const initialState = {
    isLoadingNames: false,
    listNames: [],

    isLoadingKeyUser: false,
    listKeyUser: [],

    isLoadingFunctional: false,
    listFunctional: [],

    isLoadListSystems: false,
    listSystems: [],

    filter: {
        listNames: [],
        listKeyUser: [],
        listFunctional: [],
    },

    pagination: {
        current: 1,
        pageSize: 25,
        total: 0,
        column: '',
        order: ''
    },

    isLoadExport: false,
    isSaveRecord: false,

    systemSpecialty: [],
    isLoadSystemSpecialty: false,

    isLoadingAllKeyUser: false,
    listAllKeyUser: [],

};

export const SystemReducer = (state = initialState, action) => {
    switch (action.type) {
        //Obtiene el combo nombres de sistema
        case ACTIONS.GET_SYSTEM_NAMES_REQUEST:
            return {
                ...state,
                isLoadingNames: true,
            };
        case ACTIONS.GET_SYSTEM_NAMES_SUCCESS:
            return {
                ...state,
                isLoadingNames: false,
                listNames: action.payload,
            };
        case ACTIONS.GET_SYSTEM_NAMES_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadingNames: false,
            };
        //Obtiene el combo nombres de KeyUsers
        case ACTIONS.GET_KEYUSER_NAMES_REQUEST:
            return {
                ...state,
                isLoadingKeyUser: true,
            };
        case ACTIONS.GET_KEYUSER_NAMES_SUCCESS:
            return {
                ...state,
                isLoadingKeyUser: false,
                listKeyUser: action.payload,
            };
        case ACTIONS.GET_KEYUSER_NAMES_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadingKeyUser: false,
            };
        //Obtiene el combo nombres de KeyUsers
        case ACTIONS.GET_ALLKEYUSER_NAMES_REQUEST:
            return {
                ...state,
                isLoadingAllKeyUser: true,
            };
        case ACTIONS.GET_ALLKEYUSER_NAMES_SUCCESS:
            return {
                ...state,
                isLoadingAllKeyUser: false,
                listAllKeyUser: action.payload,
            };
        case ACTIONS.GET_ALLKEYUSER_NAMES_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadingAllKeyUser: false,
            };
        //Obtiene el combo nombres de funcionales
        case ACTIONS.GET_FUNCTIONAL_NAMES_REQUEST:
            return {
                ...state,
                isLoadingFunctional: true,
            };
        case ACTIONS.GET_FUNCTIONAL_NAMES_SUCCESS:
            return {
                ...state,
                isLoadingFunctional: false,
                listFunctional: action.payload,
            };
        case ACTIONS.GET_FUNCTIONAL_NAMES_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadingFunctional: false,
            };

        //Obtiene los tipos de capacitación
        case ACTIONS.FETCH_SYSTEM_REQUEST:
            return {
                ...state,
                isLoadListSystems: true,
            };
        case ACTIONS.FETCH_SYSTEM_SUCCESS:
            return {
                ...state,
                isLoadListSystems: false,
                listSystems: action.payload,
                pagination: { ...state.pagination, total: action.payload.length > 0 ? action.payload[0].totalCount : 0 }
            };
        case ACTIONS.FETCH_SYSTEM_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadListSystems: false,
            };

        //Guarda el paginador
        case ACTIONS.SAVE_PAGINATION:
            return {
                ...state,
                pagination: action.payload
            }

        //Exporta los datos
        case ACTIONS.EXPORT_SYSTEM_REQUEST:
            return {
                ...state,
                isLoadExport: true
            };
        case ACTIONS.EXPORT_SYSTEM_SUCCESS:
            return {
                ...state,
                isLoadExport: false
            };
        case ACTIONS.EXPORT_SYSTEM_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadExport: false
            };

        //Inserta o actualiza el registro
        case ACTIONS.INSUPD_SYSTEM_REQUEST:
            return {
                ...state,
                isSaveRecord: true
            }
        case ACTIONS.INSUPD_SYSTEM_SUCCESS:
            message.success(action.payload);
            return {
                ...state,
                isSaveRecord: false
            };
        case ACTIONS.INSUPD_SYSTEM_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isSaveRecord: false
            };

        //borrar el registro de manera logica
        case ACTIONS.DELETE_SYSTEM_REQUEST:
            return {
                ...state,
                isdeleteRecord: true
            }
        case ACTIONS.DELETE_SYSTEM_SUCCESS:
            message.success(action.payload);
            return {
                ...state,
                isdeleteRecord: false
            };
        case ACTIONS.DELETE_SYSTEM_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isdeleteRecord: false
            };

        //Guarda los filtros
        case ACTIONS.SAVE_FILTER:
            return {
                ...state,
                filter: action.payload,
            };

        //Obtiene los sistemas y especialidades
        case ACTIONS.GET_SYSTEMSPECIALTY_REQUEST:
            return {
                ...state,
                isLoadSystemSpecialty: true
            }
        case ACTIONS.GET_SYSTEMSPECIALTY_SUCCESS:
            return {
                ...state,
                isLoadSystemSpecialty: false,
                systemSpecialty: action.payload
            }
        case ACTIONS.GET_SYSTEMSPECIALTY_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadSystemSpecialty: false
            }

        //Limpia el reducer
        case ACTIONS.CLEAR_REDUCER:
            return initialState;

        default:
            return state;
    }
};
